// LineChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register the required components with Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // Register the datalabels plugin
);

const LineChart = ({ labels, dataSets, colors }) => {
  // Apply colors to datasets dynamically
  const datasetsWithColors = dataSets.map((dataset, index) => ({
    ...dataset,
    borderColor: colors[index]?.borderColor || 'rgba(0, 0, 0, 0.1)', // Default color if not provided
    backgroundColor: colors[index]?.backgroundColor || 'rgba(0, 0, 0, 0.1)', // Default color if not provided
  }));

  const data = {
    labels: labels, // X-axis labels
    datasets: datasetsWithColors // Array of data objects with colors applied
  };

  const options = {
    responsive: true,
    title: false,
    maintainAspectRatio: false,
    plugins: {
      datalabels:{
        display: false,
      },
      legend: {
        display: true, // Show or hide the legend
          position: 'bottom', // Position of the legend
          align: 'center', // Alignment of the legend
          labels: {             
            padding: (0, 15, 0, 10), // Padding around the legend labels
            boxWidth: 7, // Width of the color box in the legend
            boxHeight: 7, // Height of the color box in the legend
            usePointStyle: true, // Use point styles instead of boxes             
          },
          title: {
              display: true,
              padding: -7,
          },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`;
          }
        }
      },
      title: {
        display: false,
        text: '',
      },
      // datalabels: {
      //   display: true, // Show datalabels
      //   align: 'top',  // Align the labels above the data points
      //   anchor: 'end', // Position the labels relative to the data point
      //   color: '#000', // Label color
      //   formatter: (value) => value, // Format the value (you can customize this)
      //   font: {
      //     size: 12, // Font size of the labels
      //   },
      // },
      
    },
    scales: {
      x: {
        padding: 0,
        grid:{
            display: false,
        },
        title: {
            display: false,
        },
        ticks: {
            beginAtZero: true,
            padding: 0, 
            display: true, // Hides the y-axis labels
          },
        beginAtZero: true,
      },
      y: {
        title: {
          display: true,
          text: 'Y Axis'
        },
        grid:{
          display: false,
       },
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
